var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('a',{on:{"click":function($event){_vm.setInvoiceToRemove({ playerId: _vm.playerId })}}},[_c('span')]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }